import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import RemoteControllerPanel from './RemoteControllerPanel';
import { REMOTE_DESIGN_CLASS } from '../../utils/remoteDesignTheme';

/** 메인 앱 리모컨 모달 — 열려 있는 동안만 마운트되어 Realtime 연결 */
const RemoteControllerModal: React.FC<{ open: boolean; onClose: () => void }> = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || typeof document === 'undefined') return null;
  return createPortal(
    <div className="cp-modal-backdrop" onMouseDown={onClose}>
      <div
        className={`cp-modal cp-remote-modal ${REMOTE_DESIGN_CLASS}`}
        role="dialog"
        aria-modal="true"
        aria-label="프레젠테이션 리모트"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <RemoteControllerPanel
          headerExtra={
            <button type="button" className="cp-remote-modal-close" onClick={onClose} aria-label="닫기">
              ×
            </button>
          }
        />
      </div>
    </div>,
    document.body
  );
};

export default RemoteControllerModal;
